import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons"
import { DemandeAbsenceType } from "../../api/DemandeAbsence/types"

export default function SousElementKanbanDemande({demande}: {demande: DemandeAbsenceType}){
    if(demande?.piecesjointes !== undefined && demande.piecesjointes > 0){
        return(<MaterialCommunityIcons name="paperclip" size={15}/>)
    }
    return null
}
